import type { ReduxState } from './index';

export const isSignedInSelector = (state: ReduxState) => {
  return state.session.authorized;
};

export const isAppBlockedSelector = (state: ReduxState) => {
  return state.session.authorized && !state.session.hasConsents;
};
